import React from 'react';
import PropTypes from 'prop-types';

import { MultiFilePreview, PrimaryButton, TextInputPreview } from "../../../components";

export const CedulasPreview = ({ usuario, handleEditarCedulas }) => {
  return (
    <>
        <div className="row">
            <div className="col-md-12 col-lg">
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xs-1">
                        <TextInputPreview
                            label="Médicina general"
                            name="numeroMedicinaGeneral"
                            value={ (typeof usuario.numeroMedicinaGeneral !== 'undefined') ? usuario.numeroMedicinaGeneral : '-' }
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-9 col-lg-10 col-xs-11">
                        {(typeof usuario.cedulaMedicinaGeneral !== 'undefined' && usuario.cedulaMedicinaGeneral !== null) &&
                        <MultiFilePreview
                            label=""
                            name="cedulaMedicinaGeneral"
                            files={[{ archivo: usuario.cedulaMedicinaGeneral, archivoName: usuario.cedulaMedicinaGeneralName }]}
                        />
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xs-1">
                        <TextInputPreview
                            label="Especialidad"
                            name="numeroEspecialidad"
                            value={ (typeof usuario.numeroEspecialidad !== 'undefined') ? usuario.numeroEspecialidad : '-' }
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-9 col-lg-10 col-xs-11">
                        {(typeof usuario.cedulaEspecialidad !== 'undefined' && usuario.cedulaEspecialidad !== null) &&
                        <MultiFilePreview
                            label=""
                            name="cedulaEspecialidad"
                            files={[{ archivo: usuario.cedulaEspecialidad, archivoName: usuario.cedulaEspecialidadName }]}
                        />
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xs-1">
                        <TextInputPreview
                            label="Alergia e inmunología Clínica"
                            name="numeroAlergia"
                            value={ (typeof usuario.numeroAlergia !== 'undefined') ? usuario.numeroAlergia : '-' }
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-9 col-lg-10 col-xs-11">
                        {(typeof usuario.cedulaAlergia !== 'undefined' && usuario.cedulaAlergia !== null) &&
                        <MultiFilePreview
                            label=""
                            name="cedulaAlergia"
                            files={[{ archivo: usuario.cedulaAlergia, archivoName: usuario.cedulaAlergiaName }]}
                        />
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xs-1">
                        <TextInputPreview
                            label="Consejo de alergia"
                            name="numeroConsejoAlergia"
                            value={ (typeof usuario.numeroConsejoAlergia !== 'undefined') ? usuario.numeroConsejoAlergia : '-' }
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-9 col-lg-10 col-xs-11">
                        {(typeof usuario.cedulaConsejoAlergia !== 'undefined' && usuario.cedulaConsejoAlergia !== null) &&
                        <MultiFilePreview
                            label=""
                            name="cedulaConsejoAlergia"
                            files={[{ archivo: usuario.cedulaConsejoAlergia, archivoName: usuario.cedulaConsejoAlergiaName }]}
                        />
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <PrimaryButton
                            inverse={true}
                            onClick={handleEditarCedulas}
                            text="Editar Cédulas"
                            type="button"
                        />
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

CedulasPreview.propTypes = {
    usuario: PropTypes.object.isRequired,
    handleEditarCedulas: PropTypes.func.isRequired
}